export const VISIBLE_ITEM_COUNT = 1;
//# sourceMappingURL=visibleItemCount.js.map